import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"
import { schoolAssessmentsService } from "@data/services/schoolAssessmentsService"

const initialState = {
    byStudentId: {}, // { [studentId]: [...assessments] }
    current: null,
}

export function schoolAssessments(state = initialState, action) {
    switch (action.type) {
        // Reset on logout
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        case schoolAssessmentsService.getSchoolAssessments.name +
            apiConstants._SUCCESS: {
            const studentId = action.urlParams?.student_id
            if (!studentId) return state
            return {
                ...state,
                byStudentId: {
                    ...state.byStudentId,
                    [studentId]: action.data || [],
                },
            }
        }

        case schoolAssessmentsService.getSchoolAssessment.name +
            apiConstants._SUCCESS:
            return {
                ...state,
                current: action?.data || null,
            }

        case schoolAssessmentsService.createSchoolAssessment.name +
            apiConstants._SUCCESS: {
            const studentId = action.data?.student_id
            if (!studentId) return state
            const existing = state.byStudentId[studentId] || []
            return {
                ...state,
                byStudentId: {
                    ...state.byStudentId,
                    [studentId]: [...existing, action.data]
                        .filter(Boolean)
                        .sort((a, b) => new Date(a.date) - new Date(b.date)),
                },
            }
        }

        case schoolAssessmentsService.updateSchoolAssessment.name +
            apiConstants._SUCCESS: {
            const studentId = action.data?.student_id
            if (!studentId) return state
            const existing = state.byStudentId[studentId] || []
            return {
                ...state,
                byStudentId: {
                    ...state.byStudentId,
                    [studentId]: existing
                        .map((a) => (a.id === action.data?.id ? action.data : a))
                        .sort((a, b) => new Date(a.date) - new Date(b.date)),
                },
                current:
                    state.current?.id === action.data?.id
                        ? action.data
                        : state.current,
            }
        }

        case schoolAssessmentsService.deleteSchoolAssessment.name +
            apiConstants._SUCCESS: {
            // Find which studentId this assessment belongs to and remove it
            // Parse to int since routeParams values are strings
            const assessmentId = parseInt(action.routeParams?.id, 10)
            if (isNaN(assessmentId)) return state
            const newByStudentId = { ...state.byStudentId }
            for (const [studentId, list] of Object.entries(newByStudentId)) {
                if (list.some((a) => a.id === assessmentId)) {
                    newByStudentId[studentId] = list.filter(
                        (a) => a.id !== assessmentId
                    )
                    break
                }
            }
            return {
                ...state,
                byStudentId: newByStudentId,
                current:
                    state.current?.id === assessmentId ? null : state.current,
            }
        }

        default:
            return state
    }
}

export default schoolAssessments
